import { __assign, __read, __spread, __values } from "tslib";
import { ProductInventoryStatus } from '../types/product';
var ProductVariantCalculator = /** @class */ (function () {
    function ProductVariantCalculator(product) {
        this.product = product;
        this.variantSelectionIds = [];
    }
    ProductVariantCalculator.prototype.setVariantSelectionIds = function (variantSelectionIds) {
        this.variantSelectionIds = variantSelectionIds;
    };
    ProductVariantCalculator.prototype.getVariantSelectionIds = function () {
        return this.variantSelectionIds;
    };
    ProductVariantCalculator.prototype.updateProduct = function (product) {
        this.product = product;
    };
    ProductVariantCalculator.prototype.getSelectionsAvailability = function () {
        return calcSelectionsAvailability({
            product: this.product,
            variantSelectionIds: this.variantSelectionIds,
        });
    };
    ProductVariantCalculator.prototype.getMediaItems = function () {
        return getProductsMediaItems({
            product: this.product,
            variantSelectionIds: this.variantSelectionIds,
        });
    };
    ProductVariantCalculator.prototype.getPriceInfo = function () {
        return getProductsPriceInfo({
            product: this.product,
            variantSelectionIds: this.variantSelectionIds,
        });
    };
    return ProductVariantCalculator;
}());
export { ProductVariantCalculator };
export function calcSelectionsAvailability(params) {
    var _a, _b;
    var product = params.product;
    return ((_b = (_a = product.options) === null || _a === void 0 ? void 0 : _a.reduce(function (result, option) {
        var _a;
        return (__assign(__assign({}, result), (_a = {}, _a[option.id] = calcSelectionAvailabilityByOption(__assign(__assign({}, params), { optionId: option.id })), _a)));
    }, {})) !== null && _b !== void 0 ? _b : {});
}
export function getProductsMediaItems(params) {
    var variantSelectionIds = params.variantSelectionIds, product = params.product;
    if (!variantSelectionIds.length) {
        return product.media;
    }
    var mediaItems = variantSelectionIds.reduce(function (resultMediaItems, selectionId) {
        var _a, _b;
        var selectionsMediaItems = (_b = (_a = getSelectionById({
            product: product,
            selectionId: selectionId,
        })) === null || _a === void 0 ? void 0 : _a.linkedMediaItems) !== null && _b !== void 0 ? _b : [];
        return __spread(resultMediaItems, selectionsMediaItems);
    }, []);
    if (!mediaItems.length) {
        return product.media;
    }
    return mediaItems;
}
export function getProductsPriceInfo(params) {
    var _a, _b, _c, _d;
    var product = params.product, variantSelectionIds = params.variantSelectionIds;
    var productItem = getProductItemBySelectionIds({
        product: product,
        selectionIds: variantSelectionIds,
    });
    return {
        price: (_a = productItem === null || productItem === void 0 ? void 0 : productItem.price) !== null && _a !== void 0 ? _a : product.price,
        formattedPrice: (_b = productItem === null || productItem === void 0 ? void 0 : productItem.formattedPrice) !== null && _b !== void 0 ? _b : product.formattedPrice,
        comparePrice: (_c = productItem === null || productItem === void 0 ? void 0 : productItem.comparePrice) !== null && _c !== void 0 ? _c : product.comparePrice,
        formattedComparePrice: (_d = productItem === null || productItem === void 0 ? void 0 : productItem.formattedComparePrice) !== null && _d !== void 0 ? _d : product.formattedComparePrice,
    };
}
function calcSelectionAvailabilityByOption(params) {
    var _a, _b;
    var product = params.product, optionId = params.optionId;
    var option = product.options.find(function (o) { return o.id === optionId; });
    return ((_b = (_a = option.selections) === null || _a === void 0 ? void 0 : _a.reduce(function (result, selection) {
        var _a;
        return (__assign(__assign({}, result), (_a = {}, _a[selection.id] = {
            isVisible: isOptionSelectionVisible(__assign(__assign({}, params), { selectionId: selection.id })),
            isSelectable: isOptionSelectionInStock(__assign(__assign({}, params), { selectionId: selection.id })),
        }, _a)));
    }, {})) !== null && _b !== void 0 ? _b : {});
}
function isOptionSelectionVisible(params) {
    var product = params.product;
    if (!product.isManageProductItems) {
        return true;
    }
    if (product.productItems.length === 0) {
        return true;
    }
    return hasSomeProductItem(__assign(__assign({}, params), { checker: function (_a) {
            var productItem = _a.productItem;
            return productItem.isVisible;
        } }));
}
function isOptionSelectionInStock(params) {
    var product = params.product;
    if (!product.isManageProductItems && product.isInStock) {
        return true;
    }
    if (product.isManageProductItems && product.productItems.length === 0) {
        return true;
    }
    return hasSomeProductItem(__assign(__assign({}, params), { checker: function (_a) {
            var productItem = _a.productItem;
            return product.isTrackingInventory
                ? productItem.inventory.quantity > 0
                : productItem.inventory.status === ProductInventoryStatus.IN_STOCK;
        } }));
}
function hasSomeProductItem(params) {
    var product = params.product, selectionId = params.selectionId, variantSelectionIds = params.variantSelectionIds, checker = params.checker;
    return product.productItems.some(function (productItem) {
        var candidateVariantSelectionIds = __spread([
            selectionId
        ], filterOutSelectionIdsByOptionId({
            product: product,
            selectionIds: variantSelectionIds,
            optionId: getOptionBySelectionId({
                product: product,
                selectionId: selectionId,
            }).id,
        }));
        return candidateVariantSelectionIds.every(function (selectionIdInVariant) {
            var ok = checker({
                productItem: productItem,
            });
            if (!ok) {
                return false;
            }
            return productItem.optionsSelections.includes(selectionIdInVariant);
        });
    });
}
function filterOutSelectionIdsByOptionId(_a) {
    var product = _a.product, selectionIds = _a.selectionIds, optionId = _a.optionId;
    var blockList = product.options.find(function (o) { return o.id === optionId; }).selections.map(function (s) { return s.id; });
    return selectionIds.filter(function (id) { return !blockList.includes(id); });
}
function getOptionBySelectionId(_a) {
    var product = _a.product, selectionId = _a.selectionId;
    return product.options.find(function (option) { return option.selections.some(function (selection) { return selection.id === selectionId; }); });
}
function getSelectionById(_a) {
    var e_1, _b;
    var product = _a.product, selectionId = _a.selectionId;
    try {
        for (var _c = __values(product.options), _d = _c.next(); !_d.done; _d = _c.next()) {
            var option = _d.value;
            var selection = option.selections.find(function (s) { return s.id === selectionId; });
            if (selection) {
                return selection;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return undefined;
}
function getProductItemBySelectionIds(_a) {
    var _b;
    var product = _a.product, selectionIds = _a.selectionIds;
    return (_b = product.productItems) === null || _b === void 0 ? void 0 : _b.find(function (_a) {
        var optionsSelections = _a.optionsSelections;
        return optionsSelections.every(function (selectionId) { return selectionIds.includes(selectionId); });
    });
}
//# sourceMappingURL=ProductVariantCalculator.js.map